import * as Scrivito from "scrivito";

export const MarkerPopup = Scrivito.connect(({ coord }) => {
  const link = coord.markerWidget.get("link");
  const url = link && Scrivito.urlFor(link);

  return (
    <div className="marker-popup">
      <h5>{coord.headline || coord.address}</h5>

      <div
        dangerouslySetInnerHTML={{
          __html: coord.markerWidget.get("content"),
        }}
      />

      {link && (
        <a
          className="btn btn-sm px-2 mt-3 py-1 bg-blue"
          href={url}
          target={link.target()}
          rel="noopener noreferrer nofollow"
        >
          {link.title() || url}
        </a>
      )}
    </div>
  );
});
